import { render, staticRenderFns } from "./TitleSelectorAntV.vue?vue&type=template&id=4be30f0b&scoped=true&"
import script from "./TitleSelectorAntV.vue?vue&type=script&lang=js&"
export * from "./TitleSelectorAntV.vue?vue&type=script&lang=js&"
import style0 from "./TitleSelectorAntV.vue?vue&type=style&index=0&id=4be30f0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be30f0b",
  null
  
)

export default component.exports